import React from 'react';
import { useState } from 'react';
import burger from '../../src/assets/icons/burger.png';
import useWindowSize from './useWindowSize';
import '../App.css';

const mainNavStyle = {
    position: 'relative',
    backgroundColor: '#302e2e',
    color: 'rgb(255,255,255)',
    width: '100%',
    listStyleType: 'none',
}

export default function Nav(props) {
    const isMobile = useWindowSize().isMobile;
    
    const ulMobileStyle = {
        position: 'absolute',
        top: '60px',
        left: '5vw',
        width: '45vw',
        backgroundColor: 'rgba(18, 18, 18, 0.95)',
        backdropFilter: 'blur(8px)',
        border: '1px solid rgba(255, 255, 255, 0.1)',
        borderRadius: '8px',
        boxShadow: '0 8px 32px 0 rgba(0, 0, 0, 0.5)',
        display: 'block',
        padding: '10px 15px',
        margin: '0',
        listStyleType: 'none',
        zIndex: '10',
    }

    const pgLinks_Li_Mobile = {
        padding: '10px 0',
        color: 'rgb(255, 255, 255)',
        cursor: 'pointer',
        fontSize: '1em',
        fontWeight: 'bold',
        borderBottom: '1px solid rgba(255, 255, 255, 0.05)',
    }

    const pgLinkStyle = {
        display: 'flex',
        justifyContent: isMobile ? 'flex-start' : 'space-around',
        alignItems: 'center',
        width: isMobile ? 'auto' : '75vw',
        padding: isMobile ? '10px 5vw' : '15px 5vw',
        margin: '0',
        listStyleType: 'none',
        flexWrap: 'wrap',
    }
    
    const pgLinks_li = {
        fontSize: 'clamp(0.9rem, 1.8vw, 1.3rem)',
        fontWeight: 'bold',
        fontFamily: '"Chivo", sans-serif',
        color: 'rgb(255, 255, 255)',
        cursor: 'pointer',
        transition: 'color 0.2s',
    }

    const burger_li = {
        height: '40px',
        width: '40px',
        backgroundColor: 'rgb(255, 255, 255)',
        borderRadius: '8px',
        padding: '8px',
        border: '2px solid rgb(0,0,0)',
        cursor: 'pointer',
        display: 'block',
    }

    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const toggleMenu = () => setIsMenuOpen(prev => !prev);

    //const NAV_ITEMS = ['about', 'resume', 'DIY', 'projects', 'credentials'];
    const NAV_ITEMS = ['About', 'Resume', 'DIY', 'Projects', 'Design', 'Credentials'];

    if(!isMobile) {
        return(
            <nav className="main-nav" style = {mainNavStyle}>
                <ul id = "pageLinks" style = {pgLinkStyle}>
                    {NAV_ITEMS.map((item) => (
                        <li key = {item} style = {pgLinks_li} onClick={() => props.onNavigate(item)}>
                        {item}
                        </li>
                    ))}
                    </ul>              
            </nav>
        );
    } else {
        return(
            <nav className="main-nav-mobile" style = {mainNavStyle}>
                <ul id = "pageLinks" style = {pgLinkStyle}>
                    <li>
                        <img src={burger} style = {burger_li} onClick={toggleMenu} alt = "Menu" />    
                    </li>
                </ul>
                {isMenuOpen && (
                    <ul id = "mobilelinks" style={ulMobileStyle}>
                        {NAV_ITEMS.map(item => (
                            <li
                            key = {item}
                            style = {pgLinks_Li_Mobile}
                            onClick = {() => { 
                                props.onNavigate(item);
                                toggleMenu();
                            }}
                            >
                            {item}
                            </li>
                        ))}
                    </ul>
                )}
            </nav>
        )
    }
};